import {RemoteGetPlan} from 'data/usecases/others/selection-flow/plan-v3';
import {GetPlan} from 'domain/usecases/others/selection-flow/plan-v3';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BeneficiaryEndpoints} from 'main/factories/usecases/endpoints';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';

export const makeGetPlan = (): GetPlan => {
	const isV4 = getFeatureFlagValue(FeaturesEnum.PORTAL_FEATURE_PLANS_V4);

	const endpoint = isV4 ? BeneficiaryEndpoints.planListV4 : BeneficiaryEndpoints.planListV3;

	return new RemoteGetPlan(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
